/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Links_TitleInputs */

const cs_links_title = /** @type {(inputs: Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkazy médií`)
};

const en_links_title = /** @type {(inputs: Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media links`)
};

/**
* | output |
* | --- |
* | "Media links" |
*
* @param {Links_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const links_title = /** @type {((inputs?: Links_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Links_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_links_title(inputs)
	return cs_links_title(inputs)
});